import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function getByClientId(clientId) {
    try {
        const response = await axios.get(`${REACT_APP_API}/leads/getByClient/${clientId}`)
        return response?.data?.data
    } catch {
        throw new Error('No se pudo obtener la oportunidad del cliente')
    }
}